/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";
import { log } from '../design-system/utils/console';

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */


export const b2cPolicies = {
    names: {
        signUpSignIn: "B2C_1A_SIGNUP_SIGNIN"
    },
    authorities: {
        signUpSignIn: {
            authority: `https://talisisb2c.b2clogin.com/talisisb2c.onmicrosoft.com/B2C_1A_SIGNUP_SIGNIN`,
        }
    },
    authorityDomain: "talisisb2c.b2clogin.com"
};
export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_CLIENT_ID_B2C,
        authority: b2cPolicies.authorities.signUpSignIn.authority,
        knownAuthorities: [b2cPolicies.authorityDomain],
        redirectUri: `${window.location.protocol}//${window.location.host}/auth/`,
    },
    cache: {
        cacheLocation: "localStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        log(message);
                        return;
                    case LogLevel.Info:		
                        log(message);
                        return;
                    case LogLevel.Verbose:	
                        log(message);
                        return;
                    case LogLevel.Warning:
                        log(message);
                        return;
                    default:
                        log('msalConfig error');
                        return;
                }	
            }	
        }	
    }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    // scopes: [ "User.Read", 'email' ]
};